import 'fontsource-roboto'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import URI from 'urijs'

import Loading from '../components/loading'
import config from '../config'
import BlogListHandlerBar from '../containers/blog/BlogListHandlerBar'
import BlogListTable from '../containers/blog/BlogListTable'
import HorizontalGridDivider from '../containers/horizontalGridDivider'
import ListTitleBar from '../containers/listTitleBar'
import SideMenu from '../containers/sideMenu'
import StyledMain from '../containers/styledMain'
import TopBar from '../containers/topBar'
import VerticalGridDivder from '../containers/verticalGridDivider'
import {
  getBlogListRequest,
  getBlogStatusStatisticsRequest
} from '../redux/blog/actions'
import {
  getBlogList,
  getBlogStatistics,
  getIsFetchingBlogList
} from '../redux/blog/selectors'
import { getQuery } from '../utils/common'

const BlogList = () => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const history = useHistory()
  const query = getQuery(search)
  const {
    page = 1,
    limit = config.api.defaultQuery.limit,
    sortBy = config.api.defaultQuery.sortBy,
    sortDirection = config.api.defaultQuery.sortDirection,
    q
  } = query

  const blogStatistics = useSelector(getBlogStatistics)

  const blogList = useSelector(getBlogList)
  const isFetchingBlogList = useSelector(getIsFetchingBlogList)

  useEffect(() => {
    dispatch(getBlogStatusStatisticsRequest())
  }, [])

  useEffect(() => {
    dispatch(
      getBlogListRequest({
        page,
        limit,
        sortBy,
        sortDirection,
        q
      })
    )
  }, [search])

  const handleChangePage = (_event: unknown, newPage: number) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page: newPage + 1,
          limit,
          sortBy,
          sortDirection
        })
    )
  }

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    history.push(
      pathname +
        '?' +
        URI.buildQuery({
          page,
          limit: event.target.value,
          sortBy,
          sortDirection,
          q
        })
    )
  }

  return (
    <HorizontalGridDivider>
      <SideMenu />
      <VerticalGridDivder>
        <TopBar />
        <StyledMain>
          <ListTitleBar title={'Blog List'} statistics={blogStatistics} />
          <BlogListHandlerBar />
          {isFetchingBlogList ? (
            <Loading />
          ) : (
            <BlogListTable
              blogList={blogList}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          )}
        </StyledMain>
      </VerticalGridDivder>
    </HorizontalGridDivider>
  )
}

export default BlogList
